import { UserProfilePopulatedEntity } from '@smatchy/sdk';
import { UpdateUserPersonalData } from '../domains/update-user-personal-data';

export class LoadUserProfileAction {
  static readonly type = '[UserProfile] LoadUserProfileAction';
}

export class SetUserProfileAction {
  static readonly type = '[UserProfile] SetUserProfileAction';

  constructor(public readonly payload: UserProfilePopulatedEntity) {}
}

export class SetLanguageUserProfile {
  static readonly type = '[UserProfile] SetLanguageUserProfile';

  constructor(public readonly payload: string) {}
}

export class SetTimezoneUserProfile {
  static readonly type = '[UserProfile] SetTimezoneUserProfile';

  constructor(public readonly payload: string) {}
}

export class UpdateUserProfileAction {
  static readonly type = '[UserProfile] UpdateUserProfileAction';

  constructor(public readonly payload: UpdateUserPersonalData) {}
}

export class ChangeDisplayNameAnonymousAction {
  static readonly type = '[UserProfile] ChangeDisplayNameAnonymousAction';

  constructor(public readonly isAnonymous: boolean) {}
}

export class UpdateUserDefaultLocation {
  static readonly type = '[UserProfile] UpdateUserDefaultLocation';
}

export class UpdateUserLiveLocationAction {
  static readonly type = '[UserProfile] UpdateUserLiveLocationAction';
}

export class UpdateUserLocationVisibilityAction {
  static readonly type = '[UserProfile] UpdateUserLocationVisibilityAction';

  constructor(public readonly enabled: boolean) {}
}

export class UpdateAppearInNearbyCountAction {
  static readonly type = '[UserProfile] UpdateAppearInNearbyCountAction';

  constructor(public readonly enabled: boolean) {}
}

export class UpdateShowsEnergyEstimatesAction {
  static readonly type = '[UserProfile] UpdateShowsEnergyEstimatesAction';

  constructor(public readonly enabled: boolean) {}
}

export class LoadDeleteUserProfileEligibilityAction {
  static readonly type = '[UserProfile] LoadDeleteUserProfileEligibilityAction';
}

export class DeleteUserProfileAction {
  static readonly type = '[UserProfile] DeleteUserProfileAction';
  /** Cents of unspent credit the person agreed to lose with their account. */
  constructor(public readonly acceptedCreditLoss?: number) {}
}

export class ResetDeleteUserProfileFlowAction {
  static readonly type = '[UserProfile] ResetDeleteUserProfileFlowAction';
}

export class ResetLoadingsAction {
  static readonly type = '[UserProfile] ResetLoadingsAction';
}

export class ResetUserProfileAction {
  static readonly type = '[UserProfile] ResetUserProfileAction';
}

export class EditNotificationSettingsAction {
  static readonly type = '[App] EditNotificationSettingsAction';

  constructor(public type: 'mobile' | 'mail', public key: string, public value: boolean) {}
}
